"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgCollection = function (_a) {
    var primaryColor = _a.primaryColor, secondaryColor = _a.secondaryColor, tertiaryColor = _a.tertiaryColor, props = __rest(_a, ["primaryColor", "secondaryColor", "tertiaryColor"]);
    return (react_1.default.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 12 12" }, props),
        react_1.default.createElement("path", { stroke: primaryColor, strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 0.75, d: "M4.654 6.756h-3.27A.385.385 0 0 0 1 7.141v3.27c0 .212.172.384.385.384h3.269a.385.385 0 0 0 .384-.385V7.141a.385.385 0 0 0-.384-.385Zm5.961 0H7.346a.385.385 0 0 0-.384.385v3.27c0 .212.172.384.384.384h3.27A.385.385 0 0 0 11 10.41V7.141a.385.385 0 0 0-.385-.385ZM7.638.795H4.37a.385.385 0 0 0-.384.384v3.27c0 .212.172.384.384.384h3.27a.385.385 0 0 0 .384-.384v-3.27a.385.385 0 0 0-.385-.384Z" })));
};
exports.default = SvgCollection;
